import React from 'react'
import { useMediaQuery } from '@mui/material'
import Strip from '../../TCP-HP/Strip'
import GovtStrip from '../../TCP-HP/GovtStrip'
import MobileHeader from './MobileHeader'


function Header() {
    const isDesktop = useMediaQuery(theme => theme.breakpoints.up('lg'))
    if (isDesktop) {
        return (
            <React.Fragment>
                <Strip />
                <GovtStrip />
            </React.Fragment>

        )
    }

    return (
        <MobileHeader />
    )
}

export default Header
